import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useStatus } from '../context/StatusContext';

const ROTATE_MS = 9000;

const severityStyles: Record<string, string> = {
  info: 'bg-primary-900/40 border-b border-primary-700/50 text-primary-200',
  warning: 'bg-warning-900/40 border-b border-warning-700/50 text-warning-200',
  error: 'bg-error-900/40 border-b border-error-700/50 text-error-200',
};

const StatusBanner: React.FC = () => {
  const { banners, outagePageActive } = useStatus();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (banners.length <= 1) return;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % banners.length);
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, [banners.length]);

  if (banners.length === 0) return null;

  const current = banners[index];
  const style = severityStyles[current.severity] ?? severityStyles.info;
  const showMoreInfo = outagePageActive || current.severity === 'warning' || current.severity === 'error';
  const isUrgent = current.severity === 'warning' || current.severity === 'error';

  return (
    <motion.div
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      className={`w-full px-4 py-2.5 text-center text-sm font-medium shrink-0 flex flex-wrap items-center justify-center gap-2 sm:gap-3 ${style} ${isUrgent ? 'ring-2 ring-inset shadow-lg' : ''}`}
      role="alert"
      aria-live="polite"
    >
      <span className={isUrgent ? 'animate-pulse' : ''}>{current.message}</span>
      {showMoreInfo && (
        <Link
          to="/outage"
          className="inline-flex items-center justify-center min-h-[44px] px-3 py-2 rounded-md border border-current/50 hover:bg-white/10 transition-colors font-medium shrink-0"
        >
          More info
        </Link>
      )}
    </motion.div>
  );
};

export default StatusBanner;
